import {formValidator} from './common-utils';

export const validateTravellerForm = ({formData, isBusinessProfile, isPan}) => {
  let errors = {};
  const {
    nameDetails,
    email,
    phoneNumber,
    countryCode,

    gstNumber,
    companyName,
    businessEmail,
    travellersPan,
    travellersPanName,
    travellersPanTime,
    companyAddress,
    companyPhone,
    companyEmail,
    specialReq,
  } = formData;
  const {firstName, lastName} = nameDetails[0];
  !formValidator({type: 'name', value: firstName}) &&
    (errors['firstName'] = {message: 'Please enter a valid first name', valid: false});

  !formValidator({type: 'name', value: lastName}) &&
    (errors['lastName'] = {message: 'Please enter a valid last name', valid: false});

  !formValidator({type: 'email', value: email}) &&
    (errors['email'] = {message: 'Please enter a valid email', valid: false});
  !formValidator({type: 'mobile', value: phoneNumber}) &&
    (errors['phoneNumber'] = {message: 'Please enter a valid phone number', valid: false});

  if (isPan) {
    !formValidator({type: 'pan', value: travellersPan}) &&
      (errors['travellersPan'] = {message: 'Please enter a valid PAN number', valid: false});
    !formValidator({type: 'travellersPanName', value: travellersPanName}) &&
      (errors['travellersPanName'] = {message: 'Please enter a valid name', valid: false});
    !formValidator({type: 'travellersPanTime', value: travellersPanTime}) &&
      (errors['travellersPanTime'] = {message: 'Please confirm the pan card details', valid: false});
  }

  if (isBusinessProfile) {
    !formValidator({type: 'gstNumber', value: gstNumber}) &&
      (errors['gstNumber'] = {message: 'Please enter a valid GST number', valid: false});

    !formValidator({type: 'companyName', value: companyName}) &&
      (errors['companyName'] = {message: 'Please enter a valid company name', valid: false});

    !formValidator({type: 'businessEmail', value: businessEmail}) &&
      (errors['businessEmail'] = {message: 'Please enter a valid email', valid: false});

    !formValidator({type: 'companyAddress', value: businessEmail}) &&
      (errors['companyAddress'] = {
        message: 'Please enter a valid company address',
        valid: false,
      });

    !formValidator({type: 'companyPhone', value: companyPhone}) &&
      (errors['companyPhone'] = {message: 'Please enter a valid phone number', valid: false});

    !formValidator({type: 'companyEmail', value: companyEmail}) &&
      (errors['companyEmail'] = {message: 'Please enter a valid email', valid: false});
  }
  if (Object.keys(errors).length) return {status: false, errors};
  return {status: true};
};
